import { Validator } from '@vista-digital/validator';
import { defaultSingleItemPickerConfig, singleItemPickerImageConfigValidatorSchema } from '../../../single-item-picker/types/config';
/**
 * Default configuration options for the 3D Glasses Picker component.
 */
export const defaultThreeDGlassesPickerConfig = Object.assign(Object.assign({}, defaultSingleItemPickerConfig), { header: {
        show: true
    } });
export const threeDGlassesPickerConfigValidator = Validator.object(Object.assign(Object.assign({}, singleItemPickerImageConfigValidatorSchema), { header: Validator.object({ show: Validator.boolean() }) }));
